import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from "@angular/forms";
import { Subscription } from "rxjs";
import { Yii } from "libraries/interfaces/Yii";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IDropOption, maxViasList } from "libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.component";
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";


class Wording {
    public readonly maxVias: string = Yii.t('wui-shared-js', "Nombre d'escales");
}

@Component({
    selector: 'air-search-max-vias-form',
    templateUrl: './air-search-max-vias-form.component.html',
    styleUrls: ['./air-search-max-vias-form.component.scss']
})
export class AirSearchMaxViasFormComponent implements OnInit, OnDestroy {
    public maxViasFieldSpec: IFieldSpecs;
    public maxViasItems: IDropOption[] = maxViasList;
    public airMaxViasSearchForm: FormControl;
    public wording: Wording = new Wording();
    public airSearchForm: FormGroup;
    public airSearchMaxViasFormSubscription: Subscription;

    constructor(
        private formGroupDirective: FormGroupDirective,
    ) {
    }

    public ngOnInit(): void {
        this.initAirSearchMaxViasForm();
    }

    public ngOnDestroy(): void {
        if (this.airSearchMaxViasFormSubscription) {
            this.airSearchMaxViasFormSubscription.unsubscribe();
        }
    }

    private initAirSearchMaxViasForm(): void {
        this.airMaxViasSearchForm = new FormControl();
        this.airSearchForm = this.formGroupDirective.form;
        this.airSearchForm.addControl(EAirSearchFields.maxVias, this.airMaxViasSearchForm);
        this.maxViasFieldSpec = {
            formGroup: this.airSearchForm,
            formControlName: EAirSearchFields.maxVias,
            placeholder: Yii.t('wui-shared-js', 'Aucune préférence')
        };
    }
}


